import { IconMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerLabelSection';
import { IconMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerStyleSection';
import { IIconV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
}

export const IconExternalPointSidebar = (props: Props): JSX.Element => {
    return (
        <S_IconExternalPointSidebar className={props.className}>
            <IconMarkerLabelSection marker={props.marker} disableEditText />
            <IconMarkerStyleSection marker={props.marker} />
        </S_IconExternalPointSidebar>
    );
};

const S_IconExternalPointSidebar = styled.div``;
